import { Typography } from '@mui/material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        height: '52px',
        width: '100%',
        border: `1px solid #D0D4D9`,
        padding: '16px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        clear: 'both',
        background: 'rgba(250, 250, 250, 1)',
      }}
    >
      <Typography
        variant="body1"
        style={{
          fontSize: '12px',
          lineHeight: '20px',
          letterSpacing: '-0.006em',
        }}
      >
        © {currentYear} Bowery Valuation. All rights reserved.
      </Typography>
    </footer>
  );
};

export { Footer };
